import Icon from '../components/Icon';

const Play = Icon(
  'play',
  <>
    <path d="M6 5.29a1.25 1.25 0 0 1 1.926-1.052l10.438 6.71a1.25 1.25 0 0 1 0 2.104l-10.438 6.71A1.25 1.25 0 0 1 6 18.71z" />
  </>
);

export default Play;
